import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { PositionConsultDetailsDrawerComponent } from './position-consult/position-consult-details-drawer/position-consult-details-drawer.component';
import { PositionConsultErrorModalComponent } from './position-consult/position-consult-error-modal/position-consult-error-modal.component';
import { PositionConsultFilterComponent } from './position-consult/position-consult-filter/position-consult-filter.component';
import { PositionConsultListComponent } from './position-consult/position-consult-list/position-consult-list.component';
import { PositionConsultComponent } from './position-consult/position-consult.component';
import { PositionConsultService } from './position-consult/services/position-consult.service';

@NgModule({
  declarations: [
    PositionConsultComponent,
    PositionConsultFilterComponent,
    PositionConsultListComponent,
    PositionConsultDetailsDrawerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    ComponentsModule,
    B3DesignSystemWebModule,
    PositionConsultErrorModalComponent,
  ],
  exports: [
    PositionConsultComponent,
  ],
  providers: [
    PositionConsultService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PositionModule {}
